import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useCoachVideos() {
  const [videos, setVideos] = useState({});
  useEffect(() => {
    api
      .get("/coach-videos")
      .then((r) => setVideos(r.data || {}))
      .catch(() => setVideos({}));
  }, []);
  return videos;
}
